<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @input="onDialogUpdate"
  >
    <v-card tile>
      <v-toolbar dark>
        <v-toolbar-title>{{ filename }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="onClose"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <vue-pdf-app
        style="height: 100vh"
        :pdf="url"
        :config="pdfConfig"
      ></vue-pdf-app>
    </v-card>
  </v-dialog>
</template>

<script>
// Import VuePdfApp with default icons for buttons
import VuePdfApp from "vue-pdf-app"
import "vue-pdf-app/dist/icons/main.css"

import { slugify } from "@/utils/string"

export default {
  name: "DialogImgViewer",
  components: { VuePdfApp },
  props: {
    item: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filename() {
      return slugify(this.item.name)
    },
    url() {
      return this.item.file_url
    }
  },
  data() {
    return {
      pdfConfig: {
        toolbar: {
          toolbarViewerLeft: { findbar: false }
        }
      }
    }
  },
  methods: {
    onDialogUpdate(value) {
      if (!value) {
        this.onClose()
      }
    },
    onClose() {
      this.$emit("close", false)
    }
  }
}
</script>
